/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["agm-map[_ngcontent-%COMP%]{height:500px}.info-locations[_ngcontent-%COMP%]{font-size:13px;color:gray}"];
export { styles as styles };
